
export interface ICloseButtonProps {
    closeFunction: () => void
}

export const CloseButton = (props: ICloseButtonProps) => {
    return (
        <button
            type='button'
            aria-label='Close'
            onClick={() => props.closeFunction()}
            className='flex items-center justify-center w-9 h-9 rounded-full bg-slate-100
                       hover:bg-slate-200 active:scale-90 transition-all duration-150'>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                 className="text-slate-500"
                 aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    )
}
